module.exports = __webpack_public_path__ + "img/1618853848.006320fa.jpg";